import React, { useEffect } from "react";
import { useCrud } from "../common/crudCard/useCrud";
import { CrudLayout } from "../common/crudCard/crudLayout";
import { useHistory } from "react-router-dom";
import { deleteProfile, checkDeleteProfile, getProfiles } from "../../services/profilesService";
import { cleanString } from "../utils/cleanString";
import ProfilesTable from "./profilesTable";

export default function Profiles(props) {
  const { onLoading, onDoneLoading } = props;

  const title = "Condiciones de IVA";

  const breadcrumbs = [
    {
      title: "Inicio",
      link: "/main",
    },
    {
      title: "Perfiles de Usuario",
    },
  ];

  const history = useHistory();

  const filterData = (records, query) => {
    return records;
    return records.filter((m) => cleanString(m.descripcion).includes(cleanString(query)));
  };

  const checkBeforeDelete = async (id) => {
    const canDelete = await checkDeleteProfile(id);
    return canDelete;
  };

  const onDelete = async (id) => {
    try {
      await deleteProfile(id);
    } catch (ex) {
      throw ex;
    }
  };

  const crud = useCrud({
    defaultPath: "/profiles",
    defaultSortColumn: { path: "descripcion", order: "asc" },
    checkBeforeDelete,
    filterData,
    onDelete,
    onLoading,
    onDoneLoading,
  });

  const fetchData = async () => {
    onLoading();
    const registros = await getProfiles();
    onDoneLoading();
    if (registros === "NETWORK ERROR") return history.push("/noconnection");
    crud.updateAllRecords(registros);
  };

  const handleSearch = (query) => {
    crud.setSearchQuery(query);
    crud.setCurrentPage(1);
  };

  useEffect(() => {
    if (!crud.mounted) {
      fetchData();
      crud.setMounted(true);
    }
  }, []);

  return (
    <CrudLayout
      title={title}
      breadcrumbs={breadcrumbs}
      newLink="/profiles/nuevo"
      permisos={crud.permisos}
      filterData={filterData}
      onChangeSearch={handleSearch}
      onPageChange={crud.handlePageChange}
      totalCount={crud.totalCount}
      pageSize={crud.pageSize}
      currentPage={crud.currentPage}
    >
      <ProfilesTable
        permisos={crud.permisos}
        records={crud.records}
        onDelete={(id) => crud.handleDelete(id)}
        onEdit={(id) => crud.handleEdit(id)}
        onSort={(sortColumn) => crud.handleSort(sortColumn)}
        onView={(id) => crud.handleView(id)}
        sortColumn={crud.sortColumn}
      />
    </CrudLayout>
  );
}
